import { useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";
import { legalHtml } from "@/lib/legal";
import type { LegalDoc } from "@shared/legal";
import { LegalLinks } from "@/components/Legal";

/** The Privacy Policy or Terms of Service, public and readable before signing up. */
export function LegalPage({ doc }: { doc: LegalDoc }) {
  const html = useMemo(() => legalHtml(doc), [doc]);
  const navigate = useNavigate();
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [hash, doc]);
  return (
    <div className="min-h-dvh bg-canvas">
      <div className="mx-auto max-w-2xl px-5 pb-[calc(env(safe-area-inset-bottom)+32px)] pt-[calc(env(safe-area-inset-top)+16px)]">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}
            className="-ml-2 inline-flex size-10 items-center justify-center rounded-full hover:bg-sunken"
            aria-label="Back"
          >
            <ArrowLeft className="size-6" />
          </button>
          <Link to="/" className="flex items-center gap-2">
            <img src="/favicon.svg" alt="" className="size-8" />
            <span className="font-black tracking-tight">Meaningful Rewards</span>
          </Link>
        </div>
        {/* Our own Markdown, rendered and escaped by legal/markdown.mjs. */}
        <article className="legal mt-6" dangerouslySetInnerHTML={{ __html: html }} />
        <LegalLinks className="mt-10" />
      </div>
    </div>
  );
}
